var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-section',{attrs:{"id":"venue_governing_law","headline":this.$t('form.venue_governing_law.legend')}},[_c('checkbox',{attrs:{"id":"eeaOrEu","label":_vm.$t('form.venue_governing_law.eea_or_eu.label')},model:{value:(_vm.venueGoverningLaw.eeaOrEu),callback:function ($$v) {_vm.$set(_vm.venueGoverningLaw, "eeaOrEu", $$v)},expression:"venueGoverningLaw.eeaOrEu"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/eneforhandler/components/form/VenueGoverningLawInput.vue?vue&type=template&id=64c41f41&
// module id = null
// module chunks = 